import React from 'react';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';

import { DateInput } from '@common/components/form/inputs/date';
import { EPredicateOperators } from '@common/definitions';
import { Predicate } from '@common/types/objects';

type PredicateSelectorDateOwnProps = {
  predicate: Predicate,
  onChange: (newPredicate: Partial<Predicate>) => void,
};

const toMomentValue = (value?: unknown) => {
  if (!value) return null;
  if (moment.isMoment(value)) return value;
  return moment(value as moment.MomentInput);
};

export const PredicateSelectorDate = ({
  predicate, onChange: parentOnChange,
}: PredicateSelectorDateOwnProps) => {
  const { t } = useTranslation();

  const onChange = ({ value }: Partial<Predicate>) => parentOnChange({
    comparison: EPredicateOperators.BETWEEN,
    value,
  });

  const [fromRaw, toRaw] = Array.isArray(predicate.value) ? predicate.value : [];
  const fromValue = toMomentValue(fromRaw);
  const toValue = toMomentValue(toRaw);

  return (
    <div>
      <h4><Trans i18nKey="common:predicates_date_from" /></h4>
      <div className="dropdown-input">
        <DateInput
          value={fromValue ?? undefined}
          maxDate={toValue ?? undefined}
          placeholder={t('common:predicate_date_from_date')}
          onChange={(date) => onChange({
            value: [
              date ? date.toDate() : null,
              toValue ? toValue.toDate() : null,
            ],
          })}
        />
      </div>
      <h4><Trans i18nKey="common:predicates_date_to" /></h4>
      <div className="dropdown-input">
        <DateInput
          value={toValue ?? undefined}
          minDate={fromValue ?? undefined}
          placeholder={t('common:predicate_date_to_date')}
          onChange={(date) => onChange({
            value: [
              fromValue ? fromValue.toDate() : null,
              date ? date.toDate() : null,
            ],
          })}
        />
      </div>
    </div>
  );
};
